import React, { useEffect, useState, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import { Form, Card, FloatingLabel } from 'react-bootstrap';
import { appAbsPath, showToastMessage, buttonLoadingClass, executeLaravelAPI, userToken, uploadAssets, validateName, generateSlug, approvedCities, capitalize } from '../../Utils';
import SubmitButton from '../../shared/SubmitButton';
import { Icon } from '@iconify/react';


const NewLocationAdd = ({ onCreateFormSubmit }) => {
    console.log(approvedCities, "cities")
    const buttonClass = useRef('theme-btn btn btn-success');
    const [buttonClassLoader, setButtonClass] = useState(buttonClass.current);
    const [newLocation, setNewLocation] = useState({
        name: '',
        slug: '',
        tagline: '',
        description: '',
        landmarks: '',
        pros: '',
        cons: '',
        faqs: '',
        infrastructure: '',
        essential_services: '',
        nearby_facilities: '',
        connectivity_subheading: '',
        connectivity_description: '',
        connectivity_points: '',
        location_fundamentals: '',
        rental_range: '',
        avg_rental_yield: '',
        yoy_price_appreciation: '',
        dominant_configuration: '',
        under_construction_supply: '',
        notable_integrated_township: '',
        region: '',
        city: '',
        meta_title: '',
        meta_description: '',
        canonical_url: '',
        seo_index: '',
        apr: '',
        longitude: '',
        latitude: '',
        // polygon_coordinates: [],
        polygon_coordinates: ''
    });
    console.log(newLocation, "new")
    const [selectedCity, setSelectedCity] = useState('pune');
    console.log(selectedCity, "selectedcity")
    const [selectedRegion, setSelectedRegion] = useState(null);
    const [validationErrors, setValidationErrors] = useState({});
    const [galleryrows, setGalleryRows] = useState([{ id: 1, file: null }]);
    // const [polygonRows, setPolygonRows] = useState([{ id: 1, latitude: '', longitude: '' }]);
    const [govtdevplanfile, setGovtDevPlanFile] = useState(null);
    const [locationfile, setLocationFile] = useState(null);
    const [prosconsfile, setProsConsFile] = useState(null);

    const [prosrows, setProsRows] = useState([{ id: 1, text: null }]);
    const [consrows, setConsRows] = useState([{ id: 1, text: null }]);
    const [landmarkrows, setLandmarkRows] = useState([{ id: 1, text: null }]);
    const [faqrows, setFaqRows] = useState([{ id: 1, question: null, answer: null }]);
    const [infrarows, setInfraRows] = useState([{ id: 1, status: '', title: '', description: '' }]);
    const [essentialservicesrows, setEssentialServicesRows] = useState([{ id: 1, text: null }]);
    const [nearbyfacilitiesrows, setNearbyFacilitiesRows] = useState([{ id: 1, heading: '', points: '' }]);
    const [connectivitypointsrows, setConnectivityPointsRows] = useState([{ id: 1, title: '', distance: '' }]);
    const [locationfundamentalsrows, setLocationFundamentalsRows] = useState([{ id: 1, key: '', value: '' }]);

    const inputActiveRefs = useRef([]);

    useEffect(() => {
        document.title = 'Create New Location';
    }, []);


    //   const handleInputChange = (e) => {
    //   const { name, value } = e.target;

    //   const updatedState = {
    //     [name]:
    //       name === 'latitude' || name === 'longitude'
    //         ? value === '' ? null : Number(value)
    //         : value,
    //   };

    //   if (name === 'name') {
    //     const slug = generateSlug(value);
    //     updatedState.slug = slug;
    //     updatedState.canonical_url = '/' + slug;
    //   }

    //   setNewLocation(prev => ({
    //     ...prev,
    //     ...updatedState,
    //   }));
    // };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let slugValue;

        // ✅ Clean polygon coordinates pasted as text
        const finalValue =
            name === 'polygon_coordinates'
                ? value.replace(/\n|\r/g, '').trim()
                : value;

        const updatedState = { [name]: finalValue };

        if (name === 'name') {
            slugValue = generateSlug(finalValue);
            updatedState.slug = slugValue;
            updatedState.canonical_url = "/" + slugValue;
        }

        setNewLocation((prevState) => ({
            ...prevState,
            ...updatedState,
        }));

        // ✅ Validate cleaned value
        let error = validateInput(name, finalValue);
        setValidationErrors((prevErrors) => ({
            ...prevErrors,
            [name]: error,
        }));
    };



    //     useEffect(() => {
    //     setNewLocation(prev => ({
    //         ...prev,
    //         polygon_coordinates: polygonRows.map(row => [parseFloat(row.latitude || 0), parseFloat(row.longitude || 0)])
    //     }));
    // }, [polygonRows]);


    const validateInput = (name, value) => {
        // Your validation logic here
        let error = '';
        if (['name', 'slug', 'tagline', 'description'].includes(name)) {
            error = validateName(value);
        }

        if (name === 'apr') {
            if (isNaN(value)) {
                error = 'APR should be a number';
            }
        }
        // Add other validations as needed...
        return error;
    };

    const handleRegionChange = (event) => {
        const region = event.target.value;
        setSelectedRegion(region);
    };

    const handleCityChange = (event) => {
        const city = event.target.value;
        setSelectedCity(city);
    };

    const handleGalleryRemoveRow = (id) => {
        const updatedGalleryRows = galleryrows.filter(row => row.id !== id);
        const updatedRowsWithNewIds = updatedGalleryRows.map((row, index) => ({
            ...row,
            id: index + 1 // Reassign ids starting from 1
        }));
        setGalleryRows(updatedRowsWithNewIds);
    };

    const handleGalleryAddRow = () => {
        const newId = galleryrows.length + 1;
        const newGalleryRow = { id: newId, file: null };
        setGalleryRows([...galleryrows, newGalleryRow]);
    };

    const handleProsAddRow = () => {
        const newProsRow = { id: prosrows.length + 1, text: null };
        setProsRows([...prosrows, newProsRow]);
    };

    // const handlePolygonAddRow = () => {
    //     setPolygonRows([...polygonRows, { id: polygonRows.length + 1, latitude: '', longitude: '' }]);
    // };

    // const handlePolygonRemoveRow = (id) => {
    //     const updatedRows = polygonRows.filter(row => row.id !== id)
    //         .map((row, index) => ({ ...row, id: index + 1 }));
    //     setPolygonRows(updatedRows);
    // };

    // const handlePolygonChange = (index, field, value) => {
    //     const updatedRows = polygonRows.map((row, i) => i === index ? { ...row, [field]: value } : row);
    //     setPolygonRows(updatedRows);
    // };



    const handleProsRemoveRow = (id) => {
        const updatedProsRows = prosrows.filter(row => row.id !== id);
        const updatedProsRowsWithNewIds = updatedProsRows.map((row, index) => ({
            ...row,
            id: index + 1 // Reassign ids starting from 1
        }));

        setProsRows(updatedProsRowsWithNewIds);
    };

    const handleConsAddRow = () => {
        const newConsRow = { id: consrows.length + 1, text: null };
        setConsRows([...consrows, newConsRow]);
    };

    const handleConsRemoveRow = (id) => {
        const updatedConsRows = consrows.filter(row => row.id !== id);
        const updatedConsRowsWithNewIds = updatedConsRows.map((row, index) => ({
            ...row,
            id: index + 1 // Reassign ids starting from 1
        }));

        setConsRows(updatedConsRowsWithNewIds);
    };

    const handleLandmarkAddRow = () => {
        const newLandmarkRow = { id: landmarkrows.length + 1, text: null };
        setLandmarkRows([...landmarkrows, newLandmarkRow]);
    };

    const handleLandmarkRemoveRow = (id) => {
        const updatedLandmarkRows = landmarkrows.filter(row => row.id !== id);
        const updatedLandmarkRowsWithNewIds = updatedLandmarkRows.map((row, index) => ({
            ...row,
            id: index + 1 // Reassign ids starting from 1
        }));
        setLandmarkRows(updatedLandmarkRowsWithNewIds);
    };

    const handleFaqAddRow = () => {
        const newFaqRow = { id: faqrows.length + 1, question: null, answer: null };
        setFaqRows([...faqrows, newFaqRow]);
    };

    const handleFaqRemoveRow = (id) => {
        const updatedFaqRows = faqrows.filter(row => row.id !== id);
        const updatedFaqRowsWithNewIds = updatedFaqRows.map((row, index) => ({
            ...row,
            id: index + 1 
        }));
        setFaqRows(updatedFaqRowsWithNewIds);
    };

    const handleInfraAddRow = () => {
        const newInfraRow = { id: infrarows.length + 1, status: '', title: '', description: '' };
        setInfraRows([...infrarows, newInfraRow]);
    };

    const handleInfraRemoveRow = (id) => {
        const updatedInfraRows = infrarows.filter(row => row.id !== id);
        const updatedInfraRowsWithNewIds = updatedInfraRows.map((row, index) => ({
            ...row,
            id: index + 1 
        }));
        setInfraRows(updatedInfraRowsWithNewIds);
    };

    const handleEssentialServicesAddRow = () => {
        const newEssentialServicesRow = { id: essentialservicesrows.length + 1, text: null };
        setEssentialServicesRows([...essentialservicesrows, newEssentialServicesRow]);
    };

    const handleEssentialServicesRemoveRow = (id) => {
        const updatedEssentialServicesRows = essentialservicesrows.filter(row => row.id !== id);
        const updatedEssentialServicesRowsWithNewIds = updatedEssentialServicesRows.map((row, index) => ({
            ...row,
            id: index + 1 
        }));
        setEssentialServicesRows(updatedEssentialServicesRowsWithNewIds);
    };

    const handleNearbyFacilitiesAddRow = () => {
        const newNearbyFacilitiesRow = { id: nearbyfacilitiesrows.length + 1, heading: '', points: '' };
        setNearbyFacilitiesRows([...nearbyfacilitiesrows, newNearbyFacilitiesRow]);
    };

    const handleNearbyFacilitiesRemoveRow = (id) => {
        const updatedNearbyFacilitiesRows = nearbyfacilitiesrows.filter(row => row.id !== id);
        const updatedNearbyFacilitiesRowsWithNewIds = updatedNearbyFacilitiesRows.map((row, index) => ({
            ...row,
            id: index + 1 
        }));
        setNearbyFacilitiesRows(updatedNearbyFacilitiesRowsWithNewIds);
    };

    const handleConnectivityPointsAddRow = () => {
        const newRow = { id: connectivitypointsrows.length + 1, title: '', distance: '' };
        setConnectivityPointsRows([...connectivitypointsrows, newRow]);
    };

    const handleConnectivityPointsRemoveRow = (id) => {
        const updatedRows = connectivitypointsrows.filter(row => row.id !== id);
        const updatedRowsWithNewIds = updatedRows.map((row, index) => ({
            ...row,
            id: index + 1 
        }));
        setConnectivityPointsRows(updatedRowsWithNewIds);
    };

    const handleLocationFundamentalsAddRow = () => {
        const newRow = { id: locationfundamentalsrows.length + 1, key: '', value: '' };
        setLocationFundamentalsRows([...locationfundamentalsrows, newRow]);
    };

    const handleLocationFundamentalsRemoveRow = (id) => {
        const updatedRows = locationfundamentalsrows.filter(row => row.id !== id);
        const updatedRowsWithNewIds = updatedRows.map((row, index) => ({
            ...row,
            id: index + 1 
        }));
        setLocationFundamentalsRows(updatedRowsWithNewIds);
    };

    const handleGovtDevPlanFileChange = (event) => {
        setGovtDevPlanFile(event.target.files[0]);
    };
    const handleLocationFileChange = (event) => {
        setLocationFile(event.target.files[0]);
    };
    const handleProsConsFileChange = (event) => {
        setProsConsFile(event.target.files[0]);
    };

    const handleGalleryFileChange = (id, event) => {
        const file = event.target.files[0];
        const updatedRows = galleryrows.map(row => {
            if (row.id === id) {
                return { ...row, file };
            }
            return row;
        });
        setGalleryRows(updatedRows);
    };

    const handleProsTextChange = (event, index) => {
        const newProsText = event.target.value;
        const updatedProsRows = prosrows.map((row, i) =>
            i === index ? { ...row, text: newProsText } : row
        );
        setProsRows(updatedProsRows);
    };

    const handleConsTextChange = (event, index) => {
        const newConsText = event.target.value;
        const updatedConsRows = consrows.map((row, i) =>
            i === index ? { ...row, text: newConsText } : row
        );
        setConsRows(updatedConsRows);
    };

    const handleLandmarkTextChange = (event, index) => {
        const newlandmarkText = event.target.value;
        const updatedLandmarkRows = landmarkrows.map((row, i) =>
            i === index ? { ...row, text: newlandmarkText } : row
        );
        setLandmarkRows(updatedLandmarkRows);
    };

    const handleFaqQuestionChange = (event, index) => {
        const newQuestion = event.target.value;
        const updatedFaqRows = faqrows.map((row, i) =>
            i === index ? { ...row, question: newQuestion } : row
        );
        setFaqRows(updatedFaqRows);
    };

    const handleFaqAnswerChange = (event, index) => {
        const newAnswer = event.target.value;
        const updatedFaqRows = faqrows.map((row, i) =>
            i === index ? { ...row, answer: newAnswer } : row
        );
        setFaqRows(updatedFaqRows);
    };

    const handleInfraChange = (event, index, field) => {
        const newValue = event.target.value;
        const updatedInfraRows = infrarows.map((row, i) =>
            i === index ? { ...row, [field]: newValue } : row
        );
        setInfraRows(updatedInfraRows);
    };

    const handleEssentialServicesTextChange = (event, index) => {
        const newText = event.target.value;
        const updatedEssentialServicesRows = essentialservicesrows.map((row, i) =>
            i === index ? { ...row, text: newText } : row
        );
        setEssentialServicesRows(updatedEssentialServicesRows);
    };

    const handleNearbyFacilitiesChange = (event, index, field) => {
        const newValue = event.target.value;
        const updatedNearbyFacilitiesRows = nearbyfacilitiesrows.map((row, i) =>
            i === index ? { ...row, [field]: newValue } : row
        );
        setNearbyFacilitiesRows(updatedNearbyFacilitiesRows);
    };

    const handleConnectivityPointsChange = (event, index, field) => {
        const newValue = event.target.value;
        const updatedRows = connectivitypointsrows.map((row, i) =>
            i === index ? { ...row, [field]: newValue } : row
        );
        setConnectivityPointsRows(updatedRows);
    };

    const handleLocationFundamentalsChange = (event, index, field) => {
        const newValue = event.target.value;
        const updatedRows = locationfundamentalsrows.map((row, i) =>
            i === index ? { ...row, [field]: newValue } : row
        );
        setLocationFundamentalsRows(updatedRows);
    };

    const createLocation = async (e) => {
        e.preventDefault();
        try {
            // Check for errors
            let hasErrors = false;
            const errors = {};
            errors.name = validateName(newLocation.name);
            errors.slug = validateName(newLocation.slug);
            errors.tagline = validateName(newLocation.tagline);
            errors.description = validateName(newLocation.description);

            if (selectedRegion === null) {
                errors.region = 'Please select a region.';
            }
            if (!locationfile) {
                errors.location_image = 'Please select an image file.';
            }
            if (!prosconsfile) {
                errors.pros_cons_image = 'Please select an image file.';
            }

            const hasFile = galleryrows.some(row => row.file !== null);
            if (!hasFile) {
                errors.gallery = 'At least one image is required.';
            }

            const hasPros = prosrows.some(row => row.text !== null);
            if (!hasPros) {
                errors.prostitle = 'At least one pros is required.';
            }
            const hasCons = consrows.some(row => row.text !== null);
            if (!hasCons) {
                errors.constitle = 'At least one cons is required.';
            }
            const hasLandmark = landmarkrows.some(row => row.text !== null);
            if (!hasLandmark) {
                errors.landmarktext = 'At least one landmark is required.';
            }

            for (const key in errors) {
                if (errors[key]) {
                    hasErrors = true;
                    break;
                }
            }

            setValidationErrors(errors);
            if (hasErrors) return;

            document.getElementsByClassName('theme-btn').disabled = true;
            setButtonClass(`${buttonClass.current} ${buttonLoadingClass}`);

            const locationFormData = new FormData();
            if (locationfile) {
                locationFormData.append(`location_image`, locationfile);
            }
            if (prosconsfile) {
                locationFormData.append(`pros_cons_image`, prosconsfile);
            }
            if (govtdevplanfile) {
                locationFormData.append(`govt_development_plan`, govtdevplanfile);
            }

            galleryrows.forEach((row, index) => {
                if (row.file) {
                    locationFormData.append(`gallery[${index}]`, row.file);
                    locationFormData.append(`galleryalt[${index}]`, row.alt || 'NA');
                }
            });

            newLocation.city = selectedCity;
            newLocation.seo_index = 1;
            newLocation.landmarks = JSON.stringify(landmarkrows);
            newLocation.pros = JSON.stringify(prosrows);
            newLocation.cons = JSON.stringify(consrows);
            newLocation.faqs = JSON.stringify(faqrows);
            const validInfra = infrarows.filter(r => r.title?.trim() || r.description?.trim() || r.status?.trim());
            newLocation.infrastructure = validInfra.length ? JSON.stringify(validInfra) : '';

            const validEss = essentialservicesrows.filter(r => r.text?.trim());
            newLocation.essential_services = validEss.length ? JSON.stringify(validEss) : '';

            const validNearby = nearbyfacilitiesrows.filter(r => r.heading?.trim() || r.points?.trim());
            newLocation.nearby_facilities = validNearby.length ? JSON.stringify(validNearby) : '';

            const validConn = connectivitypointsrows.filter(r => r.title?.trim() || r.distance?.trim());
            newLocation.connectivity_points = validConn.length ? JSON.stringify(validConn) : '';

            const validFund = locationfundamentalsrows.filter(r => r.key?.trim() || r.value?.trim());
            newLocation.location_fundamentals = validFund.length ? JSON.stringify(validFund) : '';
            newLocation.region = selectedRegion;
            newLocation.apr = parseFloat(newLocation.apr);
            newLocation.polygon_coordinates = newLocation.polygon_coordinates

            // Convert polygonRows to array of arrays
            // newLocation.polygon_coordinates = JSON.stringify(polygonRows.map(row => [parseFloat(row.latitude), parseFloat(row.longitude)]));


            // console.log('Location Data:', newLocation);

            const payload = { ...newLocation };
            const newFields = [
                'infrastructure', 'essential_services', 'nearby_facilities',
                'connectivity_subheading', 'connectivity_description', 'connectivity_points',
                'location_fundamentals', 'rental_range', 'avg_rental_yield',
                'yoy_price_appreciation', 'dominant_configuration', 'under_construction_supply',
                'notable_integrated_township'
            ];

            newFields.forEach(field => {
                if (!payload[field] || payload[field].toString().trim() === '' || payload[field] === '[]') {
                    delete payload[field];
                }
            });

            const response = await executeLaravelAPI('add-location', payload, 'POST', userToken);
            await uploadAssets(`locationassets/${response.data.id}`, locationFormData, userToken);
            if (response.status === 200) {
                showToastMessage('Location created successfully', 'top-right', 'success');
            } else {
                showToastMessage('Location creation failed', 'top-right', 'error');
            }

            setButtonClass(buttonClass.current);
            document.getElementsByClassName('theme-btn').disabled = false;

        } catch (error) {
            console.error('Error creating location:', error);
            showToastMessage('Error creating location', 'top-right', 'error');
        }
        if (onCreateFormSubmit) {
            onCreateFormSubmit(newLocation);
        }
    };

    return (
        <form onSubmit={createLocation} className='locationForm' encType="multipart/form-data">
            <div className="row">
                <div className="col-md-8 mb-2">
                    <Card border="" style={{ width: '100%' }}>
                        <Card.Header>Add New Location</Card.Header>
                        <Card.Body>
                            <div className="row">
                                <div className="col-md-6 mb-2">
                                    <Form.Group className="row">
                                        <div className="col-sm-12">
                                            <FloatingLabel controlId="floatingInput" label="Name">
                                                <Form.Control placeholder="Name" type="text" name='name' value={newLocation['name']} onChange={handleInputChange} disabled={false} readOnly={false} isInvalid={!!validationErrors.name} />
                                                <Form.Control.Feedback type="invalid">
                                                    {validationErrors.name}
                                                </Form.Control.Feedback>
                                            </FloatingLabel>
                                        </div>
                                    </Form.Group>
                                </div>
                                <div className="col-md-6 mb-2">
                                    <Form.Group className="row">
                                        <div className="col-sm-12">
                                            <FloatingLabel controlId="floatingInput" label="Slug">
                                                <Form.Control placeholder="Slug" type="text" name='slug' value={newLocation['slug']} onChange={handleInputChange} disabled={false} readOnly={false} isInvalid={!!validationErrors.slug} />
                                                <Form.Control.Feedback type="invalid">
                                                    {validationErrors.slug}
                                                </Form.Control.Feedback>
                                            </FloatingLabel>
                                        </div>
                                    </Form.Group>
                                </div>
                                <div className="col-md-12 mb-2">
                                    <Form.Group className="row">
                                        <div className="col-sm-12">
                                            <FloatingLabel controlId="floatingInput" label="Tagline">
                                                <Form.Control placeholder="Tagline" type="text" name='tagline' value={newLocation['tagline']} onChange={handleInputChange} disabled={false} readOnly={false} isInvalid={!!validationErrors.tagline} />
                                                <Form.Control.Feedback type="invalid">
                                                    {validationErrors.tagline}
                                                </Form.Control.Feedback>
                                            </FloatingLabel>
                                        </div>
                                    </Form.Group>
                                </div>
                                <div className="col-md-12 mb-2">
                                    <Form.Group className="row">
                                        <div className="col-sm-12">
                                            <FloatingLabel controlId="floatingInput" label="Apr">
                                                <Form.Control
                                                    placeholder="APR"
                                                    type="number"
                                                    name='apr'
                                                    value={newLocation['apr']}
                                                    onChange={handleInputChange}
                                                    onWheel={(e) => e.currentTarget.blur()} // prevent mouse wheel changing value
                                                    onKeyDown={(e) => {
                                                        // prevent arrow keys from incrementing/decrementing the number input
                                                        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    disabled={false}
                                                    readOnly={false}
                                                    isInvalid={!!validationErrors.apr}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {validationErrors.apr}
                                                </Form.Control.Feedback>
                                            </FloatingLabel>
                                        </div>
                                    </Form.Group>
                                </div>
                                <div className="col-md-12 mb-2">
                                    <Form.Group className="row">
                                        <div className="col-sm-12">
                                            <FloatingLabel controlId="floatingInput" label="Description">
                                                <Form.Control
                                                    placeholder="Description"
                                                    as="textarea"
                                                    name='description'
                                                    value={newLocation.description}
                                                    onChange={handleInputChange}
                                                    disabled={false}
                                                    readOnly={false}
                                                    rows={20}
                                                    isInvalid={!!validationErrors.description}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {validationErrors.description}
                                                </Form.Control.Feedback>
                                            </FloatingLabel>
                                        </div>
                                    </Form.Group>
                                </div>
                                <div className="col-md-6 mb-2">
                                    <Form.Group className="row">
                                        <div className="col-sm-12">
                                            <FloatingLabel controlId="floatingLatitude" label="Latitude">
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Latitude"
                                                    name="latitude"
                                                    value={newLocation.latitude}
                                                    onChange={handleInputChange}

                                                />

                                            </FloatingLabel>
                                        </div>
                                    </Form.Group>
                                </div>

                                <div className="col-md-6 mb-2">
                                    <Form.Group className="row">
                                        <div className="col-sm-12">
                                            <FloatingLabel controlId="floatingLongitude" label="Longitude">
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Longitude"
                                                    name="longitude"
                                                    value={newLocation.longitude}
                                                    onChange={handleInputChange}

                                                />

                                            </FloatingLabel>
                                        </div>
                                    </Form.Group>
                                </div>

                                <hr />
                                <div className="col-md-6 mb-2">
                                    <Form.Group className="row">
                                        <div className="col-sm-12">
                                            <FloatingLabel controlId="floatingInput" label="Region">
                                                <select name="region" id="region" className="form-control" onChange={handleRegionChange} isInvalid={!!validationErrors.region}>
                                                    <option value="">--Select Region--</option>
                                                    <option value="East">East</option>
                                                    <option value="West">West</option>
                                                    <option value="South">South</option>
                                                    <option value="North">North</option>
                                                    <option value="Central">Central</option>
                                                </select>
                                                {validationErrors.region && (
                                                    <span style={{ color: '#dc3545' }}>{validationErrors.region}</span>
                                                )}
                                            </FloatingLabel>
                                        </div>
                                    </Form.Group>
                                </div>
                                <div className="col-md-6 mb-2">
                                    <Form.Group className="row">
                                        <div className="col-sm-12">
                                            <FloatingLabel controlId="floatingInput" label="City">
                                                <select name="city" id="city" className="form-control" onChange={handleCityChange} isInvalid={!!validationErrors.city} value={selectedCity}>
                                                    {approvedCities.map((city) => (
                                                        <option key={city} value={city}>{capitalize(city)}</option>
                                                    ))}
                                                </select>
                                                <Form.Control.Feedback type="invalid">
                                                    {validationErrors.city}
                                                </Form.Control.Feedback>
                                            </FloatingLabel>
                                        </div>
                                    </Form.Group>
                                </div>

                                <div className="col-md-6 mb-2">
                                    Pros<br />
                                    <table className='table table-responsive mt-0 p-0 mb-0 table-hover table-bordered configuration-table'>
                                        <thead>
                                            <tr className='table-secondary'>
                                                <td>No</td>
                                                <td>Pros</td>
                                                <td><button type='button' className='btn btn-outline-success rounded-circle add-config text-success' onClick={handleProsAddRow}>
                                                    <Icon icon="ic:sharp-add" style={{ fontSize: '24px' }} />
                                                </button></td>
                                            </tr>
                                        </thead>
                                        <tbody className='assetstbody'>
                                            {prosrows.map((pros, index) => (
                                                <tr key={pros.id}>
                                                    <td>{pros.id}</td>
                                                    <td><input type="text" name="prostitle[]" className="form-control"
                                                        value={pros.text}
                                                        onChange={(e) => handleProsTextChange(e, index)}
                                                    /></td>
                                                    <td>
                                                        {prosrows.length > 1 && (
                                                            <a href="#remove" rel="noopener noreferrer" onClick={() => handleProsRemoveRow(pros.id)}><Icon icon='ion:close-outline' style={{ fontSize: '30px', color: '#192951' }} /></a>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                            {validationErrors.prostitle && (
                                                <tr>
                                                    <td colSpan={5}>
                                                        <p style={{ color: '#dc3545' }}>{validationErrors.prostitle}</p>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="col-md-6 mb-2">
                                    Cons<br />
                                    <table className='table table-responsive mt-0 p-0 mb-0 table-hover table-bordered configuration-table'>
                                        <thead>
                                            <tr className='table-secondary'>
                                                <td>No</td>
                                                <td>Cons</td>
                                                <td><button type='button' className='btn btn-outline-success rounded-circle add-config text-success' onClick={handleConsAddRow}>
                                                    <Icon icon="ic:sharp-add" style={{ fontSize: '24px' }} />
                                                </button></td>
                                            </tr>
                                        </thead>
                                        <tbody className='assetstbody'>
                                            {consrows.map((cons, index) => (
                                                <tr key={cons.id}>
                                                    <td>{cons.id}</td>
                                                    <td><input type="text" name="constitle[]" className="form-control"
                                                        value={cons.text}
                                                        onChange={(e) => handleConsTextChange(e, index)}
                                                    /></td>
                                                    <td>
                                                        {consrows.length > 1 && (
                                                            <a href="#remove" rel="noopener noreferrer" onClick={() => handleConsRemoveRow(cons.id)}><Icon icon='ion:close-outline' style={{ fontSize: '30px', color: '#192951' }} /></a>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                            {validationErrors.constitle && (
                                                <tr>
                                                    <td colSpan={5}>
                                                        <p style={{ color: '#dc3545' }}>{validationErrors.constitle}</p>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="col-md-12 mb-2">
                                    Landmarks<br />
                                    <table className='table table-responsive mt-0 p-0 mb-0 table-hover table-bordered configuration-table'>
                                        <thead>
                                            <tr className='table-secondary'>
                                                <td>No</td>
                                                <td>Landmarks</td>
                                                <td><button type='button' className='btn btn-outline-success rounded-circle add-config text-success' onClick={handleLandmarkAddRow}>
                                                    <Icon icon="ic:sharp-add" style={{ fontSize: '24px' }} />
                                                </button></td>
                                            </tr>
                                        </thead>
                                        <tbody className='assetstbody'>
                                            {landmarkrows.map((landmark, index) => (
                                                <tr key={landmark.id}>
                                                    <td>{landmark.id}</td>
                                                    <td>
                                                        <textarea
                                                            name="landmarktext[]" className="form-control"
                                                            value={landmark.text}
                                                            onChange={(e) => handleLandmarkTextChange(e, index)}
                                                        /></td>
                                                    <td>
                                                        {landmarkrows.length > 1 && (
                                                            <a href="#remove" rel="noopener noreferrer" onClick={() => handleLandmarkRemoveRow(landmark.id)}><Icon icon='ion:close-outline' style={{ fontSize: '30px', color: '#192951' }} /></a>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                            {validationErrors.landmarktext && (
                                                <tr>
                                                    <td colSpan={3}>
                                                        <p style={{ color: '#dc3545' }}>{validationErrors.landmarktext}</p>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="col-md-12 mb-2">
                                    Frequently Asked Questions (FAQs)<br />
                                    <table className='table table-responsive mt-0 p-0 mb-0 table-hover table-bordered configuration-table'>
                                        <thead>
                                            <tr className='table-secondary'>
                                                <td>No</td>
                                                <td>Question</td>
                                                <td>Answer</td>
                                                <td><button type='button' className='btn btn-outline-success rounded-circle add-config text-success' onClick={handleFaqAddRow}>
                                                    <Icon icon="ic:sharp-add" style={{ fontSize: '24px' }} />
                                                </button></td>
                                            </tr>
                                        </thead>
                                        <tbody className='assetstbody'>
                                            {faqrows.map((faq, index) => (
                                                <tr key={faq.id}>
                                                    <td>{faq.id}</td>
                                                    <td>
                                                        <input type="text"
                                                            name="faqquestion[]" className="form-control"
                                                            value={faq.question || ''}
                                                            onChange={(e) => handleFaqQuestionChange(e, index)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <textarea
                                                            name="faqanswer[]" className="form-control"
                                                            value={faq.answer || ''}
                                                            onChange={(e) => handleFaqAnswerChange(e, index)}
                                                        />
                                                    </td>
                                                    <td>
                                                        {faqrows.length > 1 && (
                                                            <a href="#remove" rel="noopener noreferrer" onClick={() => handleFaqRemoveRow(faq.id)}><Icon icon='ion:close-outline' style={{ fontSize: '30px', color: '#192951' }} /></a>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="col-md-12 mb-2">
                                    Infrastructure That Can Influence Property Values<br />
                                    <table className='table table-responsive mt-0 p-0 mb-0 table-hover table-bordered configuration-table'>
                                        <thead>
                                            <tr className='table-secondary'>
                                                <td>No</td>
                                                <td>Status</td>
                                                <td>Title</td>
                                                <td>Description</td>
                                                <td><button type='button' className='btn btn-outline-success rounded-circle add-config text-success' onClick={handleInfraAddRow}>
                                                    <Icon icon="ic:sharp-add" style={{ fontSize: '24px' }} />
                                                </button></td>
                                            </tr>
                                        </thead>
                                        <tbody className='assetstbody'>
                                            {infrarows.map((infra, index) => (
                                                <tr key={infra.id}>
                                                    <td>{infra.id}</td>
                                                    <td>
                                                        <select
                                                            name="infrastatus[]" className="form-control"
                                                            value={infra.status || ''}
                                                            onChange={(e) => handleInfraChange(e, index, 'status')}
                                                        >
                                                            <option value="">--Select--</option>
                                                            <option value="Ongoing">Ongoing</option>
                                                            <option value="Upcoming">Upcoming</option>
                                                            <option value="Completed">Completed</option>
                                                            <option value="Commercial">Commercial</option>
                                                        </select>
                                                    </td>
                                                    <td>
                                                        <input type="text"
                                                            name="infratitle[]" className="form-control"
                                                            value={infra.title || ''}
                                                            onChange={(e) => handleInfraChange(e, index, 'title')}
                                                        />
                                                    </td>
                                                    <td>
                                                        <textarea
                                                            name="infradescription[]" className="form-control"
                                                            value={infra.description || ''}
                                                            onChange={(e) => handleInfraChange(e, index, 'description')}
                                                        />
                                                    </td>
                                                    <td>
                                                        {infrarows.length > 1 && (
                                                            <a href="#remove" rel="noopener noreferrer" onClick={() => handleInfraRemoveRow(infra.id)}><Icon icon='ion:close-outline' style={{ fontSize: '30px', color: '#192951' }} /></a>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="col-md-12 mb-2">
                                    Essential Services Coverage<br />
                                    <table className='table table-responsive mt-0 p-0 mb-0 table-hover table-bordered configuration-table'>
                                        <thead>
                                            <tr className='table-secondary'>
                                                <td>No</td>
                                                <td>Service Point</td>
                                                <td><button type='button' className='btn btn-outline-success rounded-circle add-config text-success' onClick={handleEssentialServicesAddRow}>
                                                    <Icon icon="ic:sharp-add" style={{ fontSize: '24px' }} />
                                                </button></td>
                                            </tr>
                                        </thead>
                                        <tbody className='assetstbody'>
                                            {essentialservicesrows.map((service, index) => (
                                                <tr key={service.id}>
                                                    <td>{service.id}</td>
                                                    <td>
                                                        <input type="text"
                                                            name="essentialservicestext[]" className="form-control"
                                                            value={service.text || ''}
                                                            onChange={(e) => handleEssentialServicesTextChange(e, index)}
                                                        />
                                                    </td>
                                                    <td>
                                                        {essentialservicesrows.length > 1 && (
                                                            <a href="#remove" rel="noopener noreferrer" onClick={() => handleEssentialServicesRemoveRow(service.id)}><Icon icon='ion:close-outline' style={{ fontSize: '30px', color: '#192951' }} /></a>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="col-md-12 mb-2">
                                    Nearby Facilities (Schools, Hospitals, etc.)<br />
                                    <table className='table table-responsive mt-0 p-0 mb-0 table-hover table-bordered configuration-table'>
                                        <thead>
                                            <tr className='table-secondary'>
                                                <td>No</td>
                                                <td>Heading</td>
                                                <td>Points (One per line)</td>
                                                <td><button type='button' className='btn btn-outline-success rounded-circle add-config text-success' onClick={handleNearbyFacilitiesAddRow}>
                                                    <Icon icon="ic:sharp-add" style={{ fontSize: '24px' }} />
                                                </button></td>
                                            </tr>
                                        </thead>
                                        <tbody className='assetstbody'>
                                            {nearbyfacilitiesrows.map((facility, index) => (
                                                <tr key={facility.id}>
                                                    <td>{facility.id}</td>
                                                    <td>
                                                        <input type="text"
                                                            name="nearbyfacilitiesheading[]" className="form-control"
                                                            value={facility.heading || ''}
                                                            onChange={(e) => handleNearbyFacilitiesChange(e, index, 'heading')}
                                                            placeholder="e.g. TOP SCHOOLS NEARBY"
                                                        />
                                                    </td>
                                                    <td>
                                                        <textarea
                                                            name="nearbyfacilitiespoints[]" className="form-control"
                                                            value={facility.points || ''}
                                                            onChange={(e) => handleNearbyFacilitiesChange(e, index, 'points')}
                                                            placeholder="Indira National School, Wakad&#10;City Pride School, PCMC"
                                                            rows="4"
                                                        />
                                                    </td>
                                                    <td>
                                                        {nearbyfacilitiesrows.length > 1 && (
                                                            <a href="#remove" rel="noopener noreferrer" onClick={() => handleNearbyFacilitiesRemoveRow(facility.id)}><Icon icon='ion:close-outline' style={{ fontSize: '30px', color: '#192951' }} /></a>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="col-md-12 mb-2">
                                    <Form.Group className="row">
                                        <div className="col-sm-12">
                                            <FloatingLabel controlId="floatingInput" label="Connectivity Subheading">
                                                <Form.Control placeholder="Strategically placed..." type="text" name='connectivity_subheading' value={newLocation['connectivity_subheading']} onChange={handleInputChange} disabled={false} readOnly={false} />
                                            </FloatingLabel>
                                        </div>
                                    </Form.Group>
                                </div>
                                <div className="col-md-12 mb-2">
                                    <Form.Group className="row">
                                        <div className="col-sm-12">
                                            <FloatingLabel controlId="floatingInput" label="Connectivity Description">
                                                <Form.Control
                                                    placeholder="Connectivity Description"
                                                    as="textarea"
                                                    name='connectivity_description'
                                                    value={newLocation.connectivity_description}
                                                    onChange={handleInputChange}
                                                    disabled={false}
                                                    readOnly={false}
                                                    style={{ height: '150px' }}
                                                />
                                            </FloatingLabel>
                                        </div>
                                    </Form.Group>
                                </div>
                                <div className="col-md-12 mb-2">
                                    Connectivity Points<br />
                                    <table className='table table-responsive mt-0 p-0 mb-0 table-hover table-bordered configuration-table'>
                                        <thead>
                                            <tr className='table-secondary'>
                                                <td>No</td>
                                                <td>Title</td>
                                                <td>Distance / Time</td>
                                                <td><button type='button' className='btn btn-outline-success rounded-circle add-config text-success' onClick={handleConnectivityPointsAddRow}>
                                                    <Icon icon="ic:sharp-add" style={{ fontSize: '24px' }} />
                                                </button></td>
                                            </tr>
                                        </thead>
                                        <tbody className='assetstbody'>
                                            {connectivitypointsrows.map((point, index) => (
                                                <tr key={point.id}>
                                                    <td>{point.id}</td>
                                                    <td>
                                                        <input type="text"
                                                            className="form-control"
                                                            value={point.title || ''}
                                                            onChange={(e) => handleConnectivityPointsChange(e, index, 'title')}
                                                            placeholder="MUMBAI-PUNE EXPRESSWAY"
                                                        />
                                                    </td>
                                                    <td>
                                                        <input type="text"
                                                            className="form-control"
                                                            value={point.distance || ''}
                                                            onChange={(e) => handleConnectivityPointsChange(e, index, 'distance')}
                                                            placeholder="~1-2 km / 5 mins"
                                                        />
                                                    </td>
                                                    <td>
                                                        {connectivitypointsrows.length > 1 && (
                                                            <a href="#remove" rel="noopener noreferrer" onClick={() => handleConnectivityPointsRemoveRow(point.id)}><Icon icon='ion:close-outline' style={{ fontSize: '30px', color: '#192951' }} /></a>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="col-md-12 mb-2">
                                    Location Fundamentals<br />
                                    <table className='table table-responsive mt-0 p-0 mb-0 table-hover table-bordered configuration-table'>
                                        <thead>
                                            <tr className='table-secondary'>
                                                <td>No</td>
                                                <td>Key</td>
                                                <td>Value</td>
                                                <td><button type='button' className='btn btn-outline-success rounded-circle add-config text-success' onClick={handleLocationFundamentalsAddRow}>
                                                    <Icon icon="ic:sharp-add" style={{ fontSize: '24px' }} />
                                                </button></td>
                                            </tr>
                                        </thead>
                                        <tbody className='assetstbody'>
                                            {locationfundamentalsrows.map((rowItem, index) => (
                                                <tr key={rowItem.id}>
                                                    <td>{rowItem.id}</td>
                                                    <td>
                                                        <input type="text"
                                                            className="form-control"
                                                            value={rowItem.key || ''}
                                                            onChange={(e) => handleLocationFundamentalsChange(e, index, 'key')}
                                                            placeholder="Pin Code"
                                                        />
                                                    </td>
                                                    <td>
                                                        <input type="text"
                                                            className="form-control"
                                                            value={rowItem.value || ''}
                                                            onChange={(e) => handleLocationFundamentalsChange(e, index, 'value')}
                                                            placeholder="411033"
                                                        />
                                                    </td>
                                                    <td>
                                                        {locationfundamentalsrows.length > 1 && (
                                                            <a href="#remove" rel="noopener noreferrer" onClick={() => handleLocationFundamentalsRemoveRow(rowItem.id)}><Icon icon='ion:close-outline' style={{ fontSize: '30px', color: '#192951' }} /></a>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="col-md-4 mb-2">
                                    <Form.Group className="row">
                                        <div className="col-sm-12">
                                            <FloatingLabel controlId="floatingInput" label="Rental Range (2 BHK)">
                                                <Form.Control placeholder="e.g. ₹18,000 - ₹23,000/mo" type="text" name='rental_range' value={newLocation['rental_range']} onChange={handleInputChange} />
                                            </FloatingLabel>
                                        </div>
                                    </Form.Group>
                                </div>
                                <div className="col-md-4 mb-2">
                                    <Form.Group className="row">
                                        <div className="col-sm-12">
                                            <FloatingLabel controlId="floatingInput" label="Avg Rental Yield">
                                                <Form.Control placeholder="e.g. ~4% per annum" type="text" name='avg_rental_yield' value={newLocation['avg_rental_yield']} onChange={handleInputChange} />
                                            </FloatingLabel>
                                        </div>
                                    </Form.Group>
                                </div>
                                <div className="col-md-4 mb-2">
                                    <Form.Group className="row">
                                        <div className="col-sm-12">
                                            <FloatingLabel controlId="floatingInput" label="YoY Price Appreciation">
                                                <Form.Control placeholder="e.g. ~13-14%" type="text" name='yoy_price_appreciation' value={newLocation['yoy_price_appreciation']} onChange={handleInputChange} />
                                            </FloatingLabel>
                                        </div>
                                    </Form.Group>
                                </div>
                                <div className="col-md-4 mb-2">
                                    <Form.Group className="row">
                                        <div className="col-sm-12">
                                            <FloatingLabel controlId="floatingInput" label="Dominant Configuration">
                                                <Form.Control placeholder="e.g. 2 & 3 BHK" type="text" name='dominant_configuration' value={newLocation['dominant_configuration']} onChange={handleInputChange} />
                                            </FloatingLabel>
                                        </div>
                                    </Form.Group>
                                </div>
                                <div className="col-md-4 mb-2">
                                    <Form.Group className="row">
                                        <div className="col-sm-12">
                                            <FloatingLabel controlId="floatingInput" label="Under-Construction Supply">
                                                <Form.Control placeholder="e.g. High" type="text" name='under_construction_supply' value={newLocation['under_construction_supply']} onChange={handleInputChange} />
                                            </FloatingLabel>
                                        </div>
                                    </Form.Group>
                                </div>
                                <div className="col-md-4 mb-2">
                                    <Form.Group className="row">
                                        <div className="col-sm-12">
                                            <FloatingLabel controlId="floatingInput" label="Notable Integrated Township">
                                                <Form.Control placeholder="e.g. Blue Ridge, Megapolis" type="text" name='notable_integrated_township' value={newLocation['notable_integrated_township']} onChange={handleInputChange} />
                                            </FloatingLabel>
                                        </div>
                                    </Form.Group>
                                </div>

                                <hr />

                                <div className="col-md-6 mb-2">
                                    <Form.Group className="row">
                                        <div className="col-sm-12">
                                            <FloatingLabel controlId="floatingInput" label="Govt. Development Plan">
                                                <Form.Control type="file" id="govt_development_plan" name="govt_development_plan" className="form-control" accept="pdf/*" onChange={handleGovtDevPlanFileChange} />
                                            </FloatingLabel>
                                        </div>
                                    </Form.Group>
                                </div>

                                <div className="col-md-6 mb-2">
                                    <Form.Group className="row">
                                        <div className="col-sm-12">
                                            <FloatingLabel controlId="floatingInput" label="Location Image">
                                                <Form.Control type="file" id="location_image" name="location_image" className="form-control" accept="image/*" onChange={handleLocationFileChange} isInvalid={!!validationErrors.location_image} />
                                                <Form.Control.Feedback type="invalid">
                                                    {validationErrors.location_image}
                                                </Form.Control.Feedback>
                                            </FloatingLabel>
                                        </div>
                                    </Form.Group>
                                </div>
                                <div className="col-md-6 mb-2">
                                    <Form.Group className="row">
                                        <div className="col-sm-12">
                                            <FloatingLabel controlId="floatingInput" label="Pros/Cons Image">
                                                <Form.Control type="file" id="pros_cons_image" name="pros_cons_image" className="form-control" accept="image/*" onChange={handleProsConsFileChange} isInvalid={!!validationErrors.pros_cons_image} />
                                                <Form.Control.Feedback type="invalid">
                                                    {validationErrors.pros_cons_image}
                                                </Form.Control.Feedback>
                                            </FloatingLabel>
                                        </div>
                                    </Form.Group>
                                </div>
                                <hr />
                                <div className="col-md-12 mb-2">
                                    Gallery<br />
                                    <table className='table table-responsive mt-0 p-0 mb-0 table-hover table-bordered configuration-table'>
                                        <thead>
                                            <tr className='table-secondary'>
                                                <td>No</td>
                                                <td>Image</td>
                                                <td>Alt Tag</td>
                                                <td>Preview</td>
                                                <td><button type='button' className='btn btn-outline-success rounded-circle add-config text-success' onClick={handleGalleryAddRow}>
                                                    <Icon icon="ic:sharp-add" style={{ fontSize: '24px' }} />
                                                </button></td>
                                            </tr>
                                        </thead>
                                        <tbody className='assetstbody'>
                                            {galleryrows.map((row) => (
                                                <tr key={row.id}>
                                                    <td>{row.id}</td>
                                                    <td>
                                                        <input type="file" className="form-control" name="gallery[]" onChange={(event) => handleGalleryFileChange(row.id, event)} /></td>
                                                    <td><input type="text" className="form-control" /></td>
                                                    <td>No Image</td>
                                                    <td>
                                                        {galleryrows.length > 1 && (
                                                            <a href="#remove" rel="noopener noreferrer" onClick={() => handleGalleryRemoveRow(row.id)}><Icon icon='ion:close-outline' style={{ fontSize: '30px', color: '#192951' }} /></a>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                            {validationErrors.gallery && (
                                                <tr>
                                                    <td colSpan={5}>
                                                        <p style={{ color: '#dc3545' }}>{validationErrors.gallery}</p>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <hr />
                                <div className="col-md-12 mb-2">
                                    <Form.Group className="row">
                                        <div className="col-sm-12">
                                            <FloatingLabel controlId="floatingInput" label="Polygon Coordinates">
                                                <Form.Control
                                                    placeholder="Polygon Coordinates"
                                                    as="textarea"
                                                    name='polygon_coordinates'
                                                    value={newLocation.polygon_coordinates}
                                                    onChange={handleInputChange}

                                                    rows={20}
                                                />

                                            </FloatingLabel>
                                        </div>
                                    </Form.Group>
                                </div>
                                {/* <hr /> */}
                                {/* <div className="col-md-12 mb-2">
                                    Polygon Coordinates<br />
                                    <table className='table table-responsive mt-0 p-0 mb-0 table-hover table-bordered configuration-table'>
                                        <thead>
                                            <tr className='table-secondary'>
                                                <td>No</td>
                                                <td>Latitude</td>
                                                <td>Longitude</td>
                                                <td>
                                                    <button type='button' className='btn btn-outline-success rounded-circle add-config text-success' onClick={handlePolygonAddRow}>
                                                        <Icon icon="ic:sharp-add" style={{ fontSize: '24px' }} />
                                                    </button>
                                                </td>
                                            </tr>
                                        </thead>
                                        <tbody className='assetstbody'>
                                            {polygonRows.map((row, index) => (
                                                <tr key={row.id}>
                                                    <td>{row.id}</td>
                                                    <td>
                                                        <input type="number" className="form-control" value={row.latitude} onChange={(e) => handlePolygonChange(index, 'latitude', e.target.value)} />
                                                    </td>
                                                    <td>
                                                        <input type="number" className="form-control" value={row.longitude} onChange={(e) => handlePolygonChange(index, 'longitude', e.target.value)} />
                                                    </td>
                                                    <td>
                                                        {polygonRows.length > 1 && (
                                                            <a href="#remove" onClick={() => handlePolygonRemoveRow(row.id)}>
                                                                <Icon icon='ion:close-outline' style={{ fontSize: '30px', color: '#192951' }} />
                                                            </a>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div> */}


                            </div>

                        </Card.Body>
                        <Card.Footer className="text-end text-muted">
                            <NavLink className='theme-btn secondary me-2' to={`${appAbsPath}/portaladmin/locations`} >
                                Cancel
                            </NavLink>
                            <SubmitButton type="submit" className={buttonClassLoader} label="Save" />
                        </Card.Footer>
                    </Card>
                </div>


                <div className="col-md-4 mb-2">
                    <Card border="" style={{ width: '100%' }}>
                        <Card.Header>Add SEO Details</Card.Header>
                        <Card.Body>
                            <div className="row">
                                <div className="col-md-12 mb-2">
                                    <Form.Group className="row">
                                        <div className="col-sm-12">
                                            <FloatingLabel controlId="floatingInput" label="Meta Title">
                                                <Form.Control placeholder="Meta Title" type="text" name='meta_title' value={newLocation['meta_title']} onChange={handleInputChange} disabled={false} readOnly={false} />
                                            </FloatingLabel>
                                        </div>
                                    </Form.Group>
                                </div>

                                <div className="col-md-12 mb-2">
                                    <Form.Group className="row">
                                        <div className="col-sm-12">
                                            <FloatingLabel controlId="floatingInput" label="Meta Description">
                                                <Form.Control placeholder="Meta Description" type="text" name='meta_description' value={newLocation['meta_description']} onChange={handleInputChange} disabled={false} readOnly={false} />
                                            </FloatingLabel>
                                        </div>
                                    </Form.Group>
                                </div>

                                <div className="col-md-12 mb-2">
                                    <Form.Group className="row">
                                        <div className="col-sm-12">
                                            <FloatingLabel controlId="floatingInput" label="Canonical Url">
                                                <Form.Control placeholder="Canonical Url" type="text" name='canonical_url' value={newLocation['canonical_url']} onChange={handleInputChange} disabled={false} readOnly={false} />
                                            </FloatingLabel>
                                        </div>
                                    </Form.Group>
                                </div>
                                <hr />
                                <div className="col-md-12 mb-2">
                                    <Form.Group className="row">
                                        <div className="col-6">
                                            <label>SEO Indexing</label>
                                        </div>
                                        <div className="col-6">
                                            <Form.Check
                                                type="switch"
                                                id="custom-switch"
                                                name="seo_index"
                                                ref={el => inputActiveRefs.current = el}
                                                checked={true}
                                            />
                                        </div>
                                    </Form.Group>
                                </div>


                            </div>
                        </Card.Body>

                    </Card>
                </div>
            </div>
        </form>
    );
};

export default NewLocationAdd;
